import { EmailRegex } from '@sprytki-frontend-apps/common/Helpers';

export const AccessCardNumber = /^([0-9]{2,30})$/;
export const AllCharacters = /(?!\s*$)^[ \p{L}+ 0-9_\W]*$/u;
export const AllCharactersANG = /(?!\s*$)^[A-Za-z0-9_\W]*$/;
export const Alphabetic = /(?!\s*$)^[ \p{L}+\s,.-]*$/u;
export const AlphabeticWithSingleSignsBetween = /^([ \p{L}+\s]+(?:[-][ \p{L}+\s]+)*)$/u;
export const AlphabeticWithSpecialSigns = /(?!\s*$)^[ \p{L}+\s,'-.-–’]*$/u;
export const AlphaNumeric = /(?!\s*$)^[ \p{L}+ 0-9\s,.-]*$/u;
export const AlphaNumericMain = /^([A-Za-z0-9])*$/;
export const AlphaNumericText = /(?!\s*$)^[-0-9/ \p{L}+&+,:;=?@#_|[\]'"<>.-^*()%!\s]*$/u;
export const AlphaNumericTextANG = /(?!\s*$)^[-0-9/A-Za-z$&+,:;=?@#_|[\]'"<>.-^*()%!\s]*$/;
export const AlphaNumericTextMultiLang = /(?!\s*$)^[-0-9/ \p{L}+&+,:;=?@#_|[\]'"<>.-–^*()%!’\s]*$/u;
export const AlphaNumericWithSingleSignsAndSlashBetween = /^([ \p{L}+0-9.\s]+(?:[-,./][ \p{L}+0-9\s]+)*)$/u;
export const AlphaNumericWithSingleSignsBetween = /^([ \p{L}+0-9.–’()\s]+(?:[,.-][ \p{L}+0-9.–’()\s]+)*)$/u;
export const AlphaNumericWithSpace = /(?!\s*$)^[ \p{L}+0-9\s]*$/u;
export const AlphaNumericWithSpaceANG = /(?!\s*$)^[A-Za-z0-9\s]*$/u;
export const CountryCode = /^[A-Z]{2}$/;
export const Decimal = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/;
export const Dimensions = /^[\d]{1,9}[.,]?[\d]{0,2}$/;
export const DiscountPrice = /^[\d ]{0,8}[.,.][\d]{1,2}$/;
export { EmailRegex };
export const ErpId = /^(\S{0,20})$/;
export const HexId = /^[0-9A-Fa-f]{1,4}$/;
export const IdentityCardNumber =
	/^([A-Z\u0391-\u03A9][ -]?([0-9]{6}|[0-9]{8})|[A-Z\u0391-\u03A9]{2,3}[ -]?[0-9]{6})$/;
export const Integer = /^-?\d+$/;
export const Letters = /(?!\s*$)^[ \p{L}+\s]*$/u;
export const LocalNumber = /^([ \p{L}+0-9.–’(\-)\s]+(?:[-/][ \p{L}+0-9.–’(\-)\s]+)*)$/u;
export const MacAddress = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
export const Numbers = /^[0-9]*$/;
export const OnlyLetters = /(?!\s*$)^[ \p{L}+\s]*$/u;
export const PassportNumber = /^[A-Z]{2}[ -]?[0-9]{7}$/;
export const Password = /^(?=.{6,50}$)(?:(?=.*\d)(?=.*[A-Z]).*)$/;
export const Percentage = /^(100(\,0{1,2})?$)|(^([1-9]([0-9])?|0)(\,[0-9]{1,2})?)$/;
export const PermanentAccessCode = /^(\d{6})$/;
export const WeekendAccessCodes = /^(\d{1,15})$/;
export const Pesel = /^([0-9]{11})$/;
export const PhoneNumber = /^(([0-9]{3}) ([0-9]{3}) ([0-9]{3}))|([0-9]{9})$/;
export const Price = /^[\d ]{0,13}[.,.]?[\d]{1,2}$/;
export const PriceShort = /^[\d ]{0,8}[.,.]?[\d]{1,2}$/;
export const Regon = /^(\d{9}|\d{14})$/;
export const TenDigits = /^(\d{10})$/;
export const StreetName = /^([ \p{L}+0-9.()'’–\s]+(?:[,.-][ \p{L}+0-9.()'’–\s]+)*)$/u;
export const TaxNumber = /^[\p{L}0-9-]{8,15}$/u;
export const TaxOfficeCode = /^\d{4}$/;
export const Windows1250 =
	/^[\x00-\x7F€‚„…†‡‰Š‹ŚŤŽŹ‘’“”•–—™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙]+$/;
export const ZipCode = /^[\p{L}|\d|–’]+(?:[- ]*[\p{L}|\d|–’])+$/u;


export const getRegexTable = (translation: any) => {
	const table = {
		countryCode: {
			value: CountryCode,
			message: translation('common.validations.countryCodeNotValid'),
		},
		phone: {
			value: PhoneNumber,
			message: translation('common.validations.phoneNotValid'),
		},
		contactPerson: {
			value: PhoneNumber,
			message: translation('common.validations.phoneNotValid'),
		},
		email: {
			value: EmailRegex,
			message: translation('common.validations.emailNotValid'),
		},
		alphaNumeric: {
			value: AlphaNumeric,
			message: translation('common.validations.formatNotValid'),
		},
		alphaNumericMain: {
			value: AlphaNumericMain,
			message: translation('common.validations.formatNotValid'),
		},
		alphaNumericText: {
			value: AlphaNumericText,
			message: translation('common.validations.formatNotValid'),
		},
		AlphaNumericTextANG: {
			value: AlphaNumericTextANG,
			message: translation('common.validations.formatNotValid'),
		},
		alphaNumericTextMultiLang: {
			value: AlphaNumericTextMultiLang,
			message: translation('common.validations.formatNotValid'),
		},
		alphaNumericWithSpace: {
			value: AlphaNumericWithSpace,
			message: translation('common.validations.formatNotValid'),
		},
		alphaNumericWithSpaceANG: {
			value: AlphaNumericWithSpaceANG,
			message: translation('common.validations.formatNotValid'),
		},
		allCharacters: {
			value: AllCharacters,
			message: translation('common.validations.formatNotValid'),
		},
		allCharactersANG: {
			value: AllCharactersANG,
			message: translation('common.validations.formatNotValid'),
		},
		alphabetic: {
			value: Alphabetic,
			message: translation('common.validations.alphabeticNotValid'),
		},
		alphabeticWithSpecialSigns: {
			value: AlphabeticWithSpecialSigns,
			message: translation('common.validations.alphabeticNotValid'),
		},
		zipCode: {
			value: ZipCode,
			message: translation('common.validations.zipCodeNotValid'),
		},
		taxNumber: {
			value: TaxNumber,
			message: translation('common.validations.taxNumberNotValid'),
		},
		numeric: {
			value: Numbers,
			message: translation('common.validations.numericNotValid'),
		},
		decimal: {
			value: Decimal,
			message: translation('common.validations.decimalNotValid'),
		},
		password: {
			value: Password,
			message: translation('common.validations.passwordNotValid'),
		},
		MacAddress: {
			value: MacAddress,
			message: translation('common.validations.requiredLength', { length: 12 }),
		},
		letters: {
			value: Letters,
			message: translation('common.validations.alphabeticNotValid'),
		},
		price: {
			value: Price,
			message: translation('common.validations.decimalNotValid'),
		},
		percentage: {
			value: Percentage,
			message: translation('common.validations.pecentageNotValid'),
		},
		priceShort: {
			value: PriceShort,
			message: translation('common.validations.decimalNotValid'),
		},
		discountPrice: {
			value: DiscountPrice,
			message: translation('common.validations.decimalNotValid'),
		},

		alphaNumericWithSingleSignsBetween: {
			value: AlphaNumericWithSingleSignsBetween,
			message: translation('common.validations.formatNotValid'),
		},
		streetName: {
			value: StreetName,
			message: translation('common.validations.formatNotValid'),
		},
		alphaNumericWithSingleSignsAndSlashBetween: {
			value: AlphaNumericWithSingleSignsAndSlashBetween,
			message: translation('common.validations.formatNotValid'),
		},
		localNumber: {
			value: LocalNumber,
			message: translation('common.validations.formatNotValid'),
		},
		onlyLetters: {
			value: OnlyLetters,
			message: translation('common.validations.formatNotValid'),
		},
		alphabeticWithSingleSignsBetween: {
			value: AlphabeticWithSingleSignsBetween,
			message: translation('common.validations.formatNotValid'),
		},
		hexId: {
			value: HexId,
			message: translation('common.validations.hexNotValid'),
		},
		accessCardNumber: {
			value: AccessCardNumber,
			message: translation('common.validations.formatNotValid'),
		},
		identityCardNumber: {
			value: IdentityCardNumber,
			message: translation('common.validations.formatNotValid'),
		},
		pesel: {
			value: Pesel,
			message: translation('common.validations.formatNotValid'),
		},
		passportNumber: {
			value: PassportNumber,
			message: translation('common.validations.formatNotValid'),
		},
		bankAccount: {
			value: AlphaNumericWithSpaceANG,
			message: translation('common.validations.bankAccountNotValid'),
		},
		erpId: {
			value: ErpId,
			message: translation('common.validations.maxLength', { length: 20 }),
		},
		permanentAccessCode: {
			value: PermanentAccessCode,
			message: translation('common.validations.requiredDigits', { length: 6 }),
		},
		PaymentDeadlineDays: {
			value: Integer,
			message: translation('common.validations.formatNotValid'),
		},
		Integer: {
			value: Integer,
			message: translation('common.validations.formatNotValid'),
		},
		windows1250: {
			value: Windows1250,
			message: translation('common.validations.formatNotValid'),
		},
		taxOfficeCode: {
			value: TaxOfficeCode,
			message: translation('common.validations.requiredDigits', { length: 4 }),
		},
		regon: {
			value: Regon,
			message: translation('common.validations.regonLength'),
		},
		tenDigits: {
			value: TenDigits,
			message: translation('common.validations.requiredDigits', { length: 10 }),
		},
		dimensions: {
			value: Dimensions,
			message: translation('common.validations.formatNotValid'),
		},
		weekendAccessCode: {
			value: WeekendAccessCodes,
			message: translation('common.validations.formatNotValid'),
		},
	};

	return table;
};
